import { useEffect } from "react";

const UploadModal = ({ isOpen, onClose, onTakePhoto, onChooseFromGallery }) => {
  // Handle escape key press
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      // Prevent background scroll when modal is open
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      {/* Backdrop with fade-in animation */}
      <div
        className="absolute inset-0 bg-[#7876A1]/50 transition-opacity duration-300"
        onClick={onClose}
      />

      {/* Modal Container with slide-up animation */}
      <div
        className="relative bg-white rounded-t-[20px] w-full  h-[264.5px] overflow-hidden shadow-2xl transform transition-transform duration-300 ease-out translate-y-0"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Top handle - always visible */}
        <div className="pt-3">
          <div className="w-14 h-1.5 bg-[#cfcfe0] rounded-full mx-auto" />
        </div>

        {/* Options - styled to match provided design */}
        <div className="px-6 pt-6 pb-8">
          <div className="flex flex-col">
            <button
              onClick={onChooseFromGallery}
              type="button"
              className="flex items-center py-4 text-left hover:bg-transparent focus:outline-none transition-all duration-200 hover:opacity-80"
            >
              <img
                src="/Vision Agent Icons/Camera Roll Icon/Camera Roll - Light purple.svg"
                alt="camera-roll"
                className="w-6 h-6 mr-4 transition-transform duration-200"
              />
              <span className="text-[#7876A1] text-[18px] font-semibold">
                Upload from camera roll
              </span>
            </button>

            <div className="border-t border-[#e6e2ef] my-2" />

            <button
              onClick={onTakePhoto}
              type="button"
              className="flex items-center py-4 text-left hover:bg-transparent focus:outline-none transition-all duration-200 hover:opacity-80"
            >
              <img
                src="/Vision Agent Icons/Camera Icon/Camera Icon-Small Light Purple.svg"
                alt="camera-small"
                className="w-6 h-6 mr-4 transition-transform duration-200"
              />
              <span className="text-[#7876A1] text-[18px] font-semibold">
                Take photos
              </span>
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .fixed > .absolute {
          animation: fadeIn 0.3s ease-out;
        }

        .fixed > .relative {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default UploadModal;
